import { render, staticRenderFns } from "./VendorCard.vue?vue&type=template&id=5422be84&scoped=true"
import script from "./VendorCard.vue?vue&type=script&lang=js"
export * from "./VendorCard.vue?vue&type=script&lang=js"
import style0 from "./VendorCard.vue?vue&type=style&index=0&id=5422be84&prod&lang=scss&scoped=true"
import style1 from "./VendorCard.vue?vue&type=style&index=1&id=5422be84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5422be84",
  null
  
)

export default component.exports